import { AgGridReact } from "ag-grid-react";
import Cookies from "js-cookie";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FetchDataTypes } from "../../api/api";
import { Grid, GridReadyEvent } from "ag-grid-community";
import { formateDataCurr, formateDataPrec } from "../../utils/types";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import clsx from "clsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";

export interface IOlympicData {
  sectorName: string,
  sectorBalance: number,
  sectorHoldingsPct :any,
  targetPct :any,
  targetBalance:any,
  buyOrSell:any,
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}



const CountryRebalance = () => {
  const dataGridRef = useRef<AgGridReact<IOlympicData>>(null);
  const [rowData, setRowData] = useState<any>();
  const [rowRebalanceData, setRowRebalanceData] = useState();
  const [newTarger, setNewTarget] = useState<any>();
  const [first, setfirst] = useState([]);
  const [rebalanceTrades, setRebalanceTrades] = useState(false);
  const [showErrormsg, setShowErrormsg] = useState(false);
  const selectedClient:any = Cookies.get("client")
  function newTarget(props: any) {
    return (
      <input
        type="number"
        className="form-control form-control--small m-auto"
        value={newTarger}
        onChange={(e) => setNewTarget(e.target.value)}
      />
    );
  }

  const hashValueGetter = (params: any) => {
    return console.log(params.data);
  };
  useEffect(() => {
  }, [first, newTarger]);

  const defColumnDefs = useMemo(
    () => ({
      sortable: true,
      //flex:1
    }),
    []
  );

  const onBtExportMain = useCallback(() => {
    dataGridRef.current!.api.exportDataAsExcel();
  }, []);

  const exportSectorData = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Country Rebalance";
    const headers = [
      [
        "Country Name",
        "Balance By Country",
        "Portfolio Balance",
        "Country Holdings %",
        "Target %",
        "Target Balance",
        "Buy / Sell",
        
      ],
    ];

    const data = rowData.map((e: any) => [
      e.countryName,
      e.balanceByCountry,
      e.portfolioBalance,
      e.countryHoldingsPct,
      e.targetPct,
      e.targetBalance,
      e.buyOrSell
     
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("CountryRebalance.pdf");
  };

  const [columns, setColumns] = useState([
    { headerName: "Country Name", field: "countryName", flex: 1, width: 200, 
    filter: "agSetColumnFilter",
          floatingFilter: true, },
    {
      headerName: "Balance By Country",
      field: "balanceByCountry",
      sortable: true,
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Portfolio Balance",
      field: "portfolioBalance",
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Country Holdings %",
      field: "countryHoldingsPct",
      cellRenderer: formateDataPrec,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Target %",
      field: "targetPct",
      cellRenderer: formateDataPrec,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Target Balance",
      field: "targetBalance",
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Buy / Sell",
      field: "buyOrSell",
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
  ]);

  const [inputvalue, setInputvalue] = useState<any>();

  function editableValue(p: any) {
    return (
      <input
        type="number"
        className="form-control"
        value={p.value}
        onChange={() => setInputvalue(p.value)}
      />
    );
  }

  function handleSubmit() {
    setRebalanceTrades((current) => !current);
  }
  
  const onGridReady = useCallback((params: GridReadyEvent) => {
    FetchDataTypes("CountryRebalance", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setRowData(response);
      });
  }, []);

  const onGridReadynew = useCallback((params: GridReadyEvent) => {
    FetchDataTypes("CountryRebalanceTrades", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setRowRebalanceData(response);
      });
  }, []);

  

  function showMessage() {
    setShowErrormsg(true);
  }
  return (
    <div className="mt-4">
      <div className="card mr-2 shadow-none">
        <div className="col-sm-3 w-100 py-3 justify-content-between tableFilters">
          <h5 className="card-title float-start">
            Country Rebalance
            {rebalanceTrades === true ? " - Trades" : null}
          </h5>
          <div className="col-sm-12 my-3 text-end">
            <i
              className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
              style={{ fontSize: "16px" }}
              onClick={onBtExportMain}
            ></i>
            <i
              className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
              onClick={() => exportSectorData()}
              style={{ fontSize: "16px" }}
            ></i>
          </div>
        </div>
        {showErrormsg && showErrormsg ? (
          // <div
          //   className="alert alert-danger alert-dismissible position-absolute statusAlert"
          //   role="alert"
          // >
          //   <div className="alert-message">
          //     Total Target % should equal 100%. Current entered Target % = 98%
          //   </div>
          //   <button
          //     type="button"
          //     className="btn-close btn-close-white"
          //     data-bs-dismiss="alert"
          //     aria-label="Close"
          //   ></button>
          // </div>
          ''
        ) : null}
        <div className="card-body p-0">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div className="chartjs-size-monitor-shrink">
                
                
                  <div
                    className="ag-theme-alpine"
                    style={{
                      height: "600px",
                      width: "100%",
                    }}
                  >
                    <AgGridReact
                      ref={dataGridRef}
                      rowData={rowData}
                      columnDefs={columns}
                      defaultColDef={defColumnDefs}
                      onGridReady={onGridReady}
                      animateRows={true}
                      popupParent={document.body}
                      pagination={true}
                  paginationPageSize= {20}
                  //paginationAutoPageSize={true}
                    ></AgGridReact>
                  </div>
               
              </div>
              <div className="row pt-4">
                <div className="float-end text-end">
                  {rebalanceTrades === true ? (
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={handleSubmit}
                    >
                      Cancel
                    </button>
                  ) : null}

                  <button
                    type="submit"
                    className={clsx("btn ",
                    rebalanceTrades === true ? 'btn-danger' : 'btn-primary'
                    )}
                    onClick={
                      rebalanceTrades === true ? showMessage : handleSubmit
                    }
                  >
                    {rebalanceTrades === true
                      ? "Place Trades"
                      : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { CountryRebalance };
